const loanPurposeOptions = [
  { value: 'debt_consolidation', label: 'Debt consolidation' },
  { value: 'credit_card_refinancing', label: 'Credit card refinancing' },
  { value: 'major_purchase', label: 'Major purchase' },
  { value: 'home_improvement', label: 'Home improvement' },
  { value: 'moving_relocation', label: 'Moving/relocation' },
  { value: 'medical_expenses', label: 'Medical expenses' },
  { value: 'car_financing', label: 'Car purchase / financing' },
  { value: 'bills_or_rent', label: 'Bills and Rent' },
  { value: 'car_repair', label: 'Car repair' },
  { value: 'business', label: 'Business' },
  { value: 'special_occasion', label: 'Special occasion' },
  { value: 'vacation', label: 'Vacation' },
  { value: 'taxes', label: 'Taxes' },
  { value: 'other', label: 'Other' },
]
const rewardsTypeOptions = [
  { value: 'rewards', label: 'Rewards' },
  { value: 'cashback', label: 'Cash Back' },
  { value: 'travel', label: 'Travel' },
  { value: 'balance-transfer', label: 'Balance Transfer' },
  { value: 'low-interest', label: 'Low Interest' },
  { value: 'zero-percent', label: 'Zero Percent Purchase' },
  { value: 'secured', label: 'Secured' },
  { value: 'student', label: 'Student' },
]
const creditScoreOptions = [
  { value: 'excellent', label: 'Excellent (720-850)' },
  { value: 'good', label: 'Good (690-719)' },
  { value: 'fair', label: 'Fair (630-689)' },
  { value: 'poor', label: 'Poor (<630)' },
]

export { loanPurposeOptions, rewardsTypeOptions, creditScoreOptions }
